import { dispatchTrackErrorEvent } from "@grandvisionhq/svc-tealium/events";
import { RECREATE_ORDERED_CHECKOUT } from "../../../../operations/mutations/operations/mutations/recreate-ordered-checkout.js";
async function recoverCheckout(apolloClient, checkoutId) {
  const { data, errors } = await apolloClient.mutate({
    mutation: RECREATE_ORDERED_CHECKOUT,
    variables: {
      orderedCheckoutInput: { checkoutId }
    }
  });
  if (errors) {
    errors.forEach((error) => console.error("recoverCheckout:", error));
    dispatchTrackErrorEvent(
      () => Promise.resolve({
        Error_Source: "Server",
        Error_Code: "Recover checkout error",
        Error_Details: errors.map((error) => error.message).join(",")
      })
    );
    throw new Error("Failed to recover checkout");
  }
  const responseData = data?.recreateOrderedCheckout;
  return responseData ? {
    success: responseData?.success,
    cartId: responseData?.newCheckoutId,
    cartHash: responseData?.checkoutHash
  } : { success: false };
}
export {
  recoverCheckout
};
//# sourceMappingURL=recover-checkout.js.map
